var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.visible ? _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report.expose",
      value: {
        f_module: _vm.isLogin ? '切换登录' : '登录',
        f_type: 0
      },
      expression: "{ f_module: isLogin ? '切换登录' : '登录', f_type: 0 }",
      modifiers: {
        "expose": true
      }
    }],
    staticClass: "mod_double_login_mask",
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "mod_double_login"
  }, [_c('i', {
    staticClass: "login__icon login__icon_cancel",
    attrs: {
      "data-role": "button"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('svg', {
    staticClass: "login__svg_icon login__svg_icon_cancel",
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.807 16.326l4.72 4.721c0.232 0.24 0.375 0.567 0.375 0.928 0 0.739-0.599 1.337-1.337 1.337-0.362 0-0.69-0.144-0.931-0.377l0 0-4.713-4.721-4.72 4.721c-0.24 0.233-0.569 0.377-0.931 0.377-0.739 0-1.337-0.599-1.337-1.337 0-0.361 0.143-0.688 0.375-0.929l-0 0 4.72-4.721-4.72-4.721c-0.232-0.24-0.375-0.568-0.375-0.928 0-0.739 0.599-1.337 1.337-1.337 0.362 0 0.69 0.144 0.931 0.377l4.72 4.721 4.713-4.721c0.24-0.233 0.569-0.377 0.931-0.377 0.739 0 1.337 0.599 1.337 1.337 0 0.361-0.143 0.688-0.375 0.929l0-0z"
    }
  })])]), _c('div', {
    staticClass: "login_hd"
  }, [_c('h1', {
    staticClass: "login_title login_lh15"
  }, [_vm._v("\n        " + _vm._s(_vm.isLogin ? '切换腾讯视频账号' : '登录腾讯视频') + "\n      ")]), _vm.canLogin && _vm.desc ? _c('div', {
    staticClass: "login_subtitle login_lh15"
  }, [_vm._v("\n        " + _vm._s(_vm.desc) + "\n      ")]) : _vm._e()]), _c('div', {
    staticClass: "login_bd"
  }, [_c('div', {
    staticClass: "login_list"
  }, [_vm.canLogin ? _c('div', {
    staticClass: "list_inner"
  }, [_c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reports.btnWechat,
      expression: "reports.btnWechat"
    }],
    staticClass: "list_item inner",
    on: {
      "click": function click($event) {
        return _vm.actionLogin('wx');
      }
    }
  }, [_c('i', {
    staticClass: "login__icon login__icon_wx_lg",
    class: {
      login__icon_gray: !_vm.enableWechatLogin
    }
  }, [_c('svg', {
    staticClass: "login__svg_icon login__svg_icon_wx_lg",
    attrs: {
      "viewBox": "0 0 61.687 48.84"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M802.443,1072.29a20.971,20.971,0,0,1,2.1.12c-1.891-8.55-11.292-14.9-22.026-14.9-12,0-21.828,7.95-21.828,18.05,0,5.82,3.268,10.61,8.733,14.32l-2.182,6.38,7.631-3.72a38,38,0,0,0,7.646,1.07q1.026,0,2.038-.09a15.389,15.389,0,0,1-.675-4.44C783.883,1079.81,792.072,1072.29,802.443,1072.29Zm-11.735-5.75a2.651,2.651,0,1,1,0,5.3c-1.64,0-3.281-1.07-3.281-2.66S789.068,1066.54,790.708,1066.54Zm-15.278,5.3c-1.638,0-3.288-1.07-3.288-2.66s1.65-2.64,3.288-2.64A2.651,2.651,0,1,1,775.43,1071.84Zm46.936,16.98c0-8.48-8.733-15.39-18.541-15.39-10.386,0-18.568,6.91-18.568,15.39,0,8.5,8.182,15.4,18.568,15.4a28.2,28.2,0,0,0,6.548-1.06l5.988,3.18-1.64-5.3C819.1,1097.84,822.366,1093.61,822.366,1088.82Zm-24.561-2.65a2.126,2.126,0,1,1,0-4.25,2.48,2.48,0,0,1,2.733,2.13C800.538,1085.12,799.454,1086.17,797.805,1086.17Zm12,0a2.125,2.125,0,1,1,0-4.25,2.485,2.485,0,0,1,2.732,2.13C812.542,1085.12,811.449,1086.17,809.81,1086.17Z",
      "transform": "translate(-760.688 -1057.5)"
    }
  })])]), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h6', {
    staticClass: "title login_lh15",
    class: {
      login__txt_sub: !_vm.enableWechatLogin
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.btnLoginWechat) + "\n                ")])])])]), _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reports.btnQQ,
      expression: "reports.btnQQ"
    }],
    staticClass: "list_item inner",
    on: {
      "click": function click($event) {
        return _vm.actionLogin('qq');
      }
    }
  }, [_c('i', {
    staticClass: "login__icon login__icon_qq_lg",
    class: {
      login__icon_gray: !_vm.enableQQLogin
    }
  }, [_c('img', {
    staticClass: "login__svg_icon login__svg_icon_qq_lg",
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })]), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm.enableQQLogin ? _c('h6', {
    staticClass: "title login_lh15",
    class: {
      login__txt_sub: !_vm.enableQQLogin
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.btnLoginQQ) + "\n                ")]) : _vm._e()])])])]) : _vm._e(), _c('div', {
    staticClass: "login_desc"
  }, [_c('div', {
    staticClass: "login_lh15",
    domProps: {
      "innerHTML": _vm._s(_vm.descText)
    },
    on: {
      "click": _vm.descTextClick
    }
  }), !_vm.canLogin ? [_vm.enableOpenApp ? _c('a', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reports.btnOpenApp,
      expression: "reports.btnOpenApp"
    }],
    staticClass: "disable_btn",
    on: {
      "click": _vm.launchApp
    }
  }, [_vm._v("打开腾讯视频")]) : _c('a', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reports.btnClipboard,
      expression: "reports.btnClipboard"
    }],
    staticClass: "disable_btn",
    on: {
      "click": _vm.clipboard
    }
  }, [_vm._v("复制链接")])] : _vm._e()], 2), _vm.canLogin ? _c('div', {
    staticClass: "login_agreement login_lh15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.isAgreementChecked,
      expression: "isAgreementChecked"
    }],
    attrs: {
      "id": "agreement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAgreementChecked) ? _vm._i(_vm.isAgreementChecked, null) > -1 : _vm.isAgreementChecked
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.isAgreementChecked,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAgreementChecked = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.isAgreementChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.isAgreementChecked = $$c;
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "agreement"
    }
  }), _c('div', {
    staticClass: "text login_lh15"
  }, [_vm._v("\n            同意"), _c('a', {
    on: {
      "click": function click($event) {
        return _vm.openAgreement(_vm.agreement.user);
      }
    }
  }, [_vm._v("《用户协议》")]), _vm._v("、"), _c('a', {
    on: {
      "click": function click($event) {
        return _vm.openAgreement(_vm.agreement.privacy);
      }
    }
  }, [_vm._v("《隐私政策》")]), _vm._v("、"), _c('a', {
    on: {
      "click": function click($event) {
        return _vm.openAgreement(_vm.agreement.kidPrivacy);
      }
    }
  }, [_vm._v("《儿童隐私保护声明》")]), _vm._v("、"), _c('a', {
    on: {
      "click": function click($event) {
        return _vm.openAgreement(_vm.agreement.personalInfo);
      }
    }
  }, [_vm._v("《个人信息采集清单》")]), _vm._v("和"), _c('a', {
    on: {
      "click": function click($event) {
        return _vm.openAgreement(_vm.agreement.thirdInfo);
      }
    }
  }, [_vm._v("《第三方信息共享清单》")])])]) : _vm._e()])])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };